import { ICellRendererParams } from '@mint-lib/ag-grid/community';
import { Chip } from '@mint-lib/tw-components';

import { RagTableType } from '../../../../types/rag.js';

const FileTypeCell = ({ data }: ICellRendererParams<RagTableType>) => {
  if (!data?.fileType) {
    return null;
  }

  return (
    <Chip variant="outline" size="small" color="info">
      <p className="capitalize">{data.fileType}</p>
    </Chip>
  );
};

export { FileTypeCell };
